import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const WITHOUT = ['Improvisas la clase cada semana', 'Sobrecargas a unos y aburres a otros', 'Pierdes alumnos en temporada baja', 'No sabes cuándo derivar a un médico', 'Tu negocio no crece ni escala', 'Vendes sin método ni guiones'];
const WITH = ['Estructura lista para repetir', 'Una clase segura para todos los niveles', 'Sistema de retención todo el año', 'Protocolo claro de seguridad y riesgo', 'Ruta clara para escalar tu oferta', 'Guiones de venta para cerrar planes'];
export function Comparison() {
  return <section className="px-5 py-10" data-id="element-54" data-mp="23xdpzqzsuqlm">
      <div className="mx-auto max-w-md" data-id="element-55" data-mp="23yeybnpfkyzn">
        <h2 className="text-center font-anton text-xl leading-tight text-white sm:text-2xl" data-id="element-56" data-mp="28x0402ngcavh">
          Sin Hyrox Definitivo 360 <span className="text-[#F5C518]" data-id="element-57" data-mp="9ke4xicnh46y">vs</span>{' '}
          Con Hyrox Definitivo 360
        </h2>

        <div className="mt-5 grid grid-cols-2 gap-2.5" data-id="element-58" data-mp="ei5u44lwuc7g">
          {/* Without */}
          <div className="rounded-xl border border-red-500/30 bg-red-500/5 p-3" data-id="element-59" data-mp="1m0h16ooeak6g">
            <h3 className="mb-3 flex items-center gap-1.5 font-oswald text-xs font-700 uppercase tracking-wide text-red-400" data-id="element-60" data-mp="1ha0lexx3qmgx">
              <XIcon className="h-4 w-4" data-id="element-61" data-mp="1d7vq7ur09hs6" /> Sin el sistema
            </h3>
            <ul className="space-y-2.5" data-id="element-62" data-mp="189atw6evji90">
              {WITHOUT.map((t, i) => <li key={i} className="flex items-start gap-1.5 text-[12px] leading-tight text-neutral-300" data-id="element-63" data-mp="1877vaxznogso" data-mpi={i}>
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-red-400" data-id="element-64" data-mp="20zb14bwul7f1" />
                  <span data-id="element-65" data-mp="1vy3tccupg88d">{t}</span>
                </li>)}
            </ul>
          </div>

          {/* With */}
          <div className="rounded-xl border border-[#F5C518]/40 bg-[#F5C518]/5 p-3" data-id="element-66" data-mp="1qz0oaseq620e">
            <h3 className="mb-3 flex items-center gap-1.5 font-oswald text-xs font-700 uppercase tracking-wide text-[#F5C518]" data-id="element-67" data-mp="kkrhpfspelbn">
              <CheckIcon className="h-4 w-4" data-id="element-68" data-mp="fjbyzue00qwf" /> Con el sistema
            </h3>
            <ul className="space-y-2.5" data-id="element-69" data-mp="h33szu2z457c">
              {WITH.map((t, i) => <li key={i} className="flex items-start gap-1.5 text-[12px] leading-tight text-white" data-id="element-70" data-mp="m15e0kjymelg" data-mpi={i}>
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#F5C518]" data-id="element-71" data-mp="83gqf4yictcp" />
                  <span data-id="element-72" data-mp="d2bkj31xe4c4">{t}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-5 text-center font-oswald text-base font-600 leading-snug text-white" data-id="element-73" data-mp="3uevsti3s08hy">
          Cientos de boxes en España enseñan HYROX: toma ventaja con este kit y no te quedes atrás.
        </p>

        <article className="mt-5 rounded-xl border border-[#F5C518]/45 bg-[#F5C518]/[0.08] p-4 text-center" data-id="element-74" data-mp="3phlxxmxmb4mq">
          <p className="font-oswald text-xs font-700 uppercase tracking-[0.16em] text-[#F5C518]" data-id="element-75" data-mp="3bi4bhe7so3gj">
            Bono exclusivo
          </p>
          <h3 className="mt-1 font-anton text-2xl leading-none text-white" data-id="element-76" data-mp="3gfmgwumls0js">
            Programador de WOD
          </h3>
          <p className="mt-3 text-[13px] leading-snug text-neutral-300" data-id="element-77" data-mp="2wx8csb1h5ga8">
            Elegís objetivo, duración, nivel del grupo y equipamiento disponible,
            y arma automáticamente una sesión completa de HYROX — con ejercicios
            sin repetir, escalados en 3 niveles a la vez — para que no tengas que
            diseñarla desde cero cada semana.
          </p>
        </article>
      </div>
    </section>;
}